import { createFileRoute } from '@tanstack/react-router';
import { CountsPage } from '@/features/inventory/CountsPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/counts/')({
  component: CountsPage,
});
